import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './conversation-card.module.scss';
import { Conversation, ConversationCategory } from '_types';
import Decorator from './decorator';
import { ReactComponent as AddIcon } from '../../images/icons/plus-lg.svg';
import userConversationImage1 from './images/user_conversation_1.png';
import userConversationImage2 from './images/user_conversation_2.png';
import userConversationImage3 from './images/user_conversation_3.png';
import defaultConversationImage from './images/default_conversation_image.png';

type ConversationCardProps = {
    category: ConversationCategory;
    children?: ReactNode;
    className?: string;
    buttonClassName?: string;
    conversation?: Conversation;
    decorator?: Decorator;
    onClick: () => void;
    imageUrl?: string;
    showAll?: boolean;
    wideConversationCard?: boolean;
};

const ConversationCard: FC<ConversationCardProps> = ({
    category,
    children,
    className,
    buttonClassName,
    conversation,
    onClick,
    showAll,
    wideConversationCard,
}) => {
    let backgroundImage = conversation?.image || defaultConversationImage;
    const userConversationClass = '';

    if (className?.toLocaleLowerCase().includes('usercreatedconversation1')) {
        backgroundImage = userConversationImage1;
    } else if (
        className?.toLocaleLowerCase().includes('usercreatedconversation2')
    ) {
        backgroundImage = userConversationImage2;
    } else if (
        className?.toLocaleLowerCase().includes('usercreatedconversation3')
    ) {
        backgroundImage = userConversationImage3;
    }

    const hasLongWords = (text: string | undefined): boolean => {
        if (text === undefined) {
            return false;
        }
        const listOfWords = text.split(' ');

        for (let i = 0; i < listOfWords.length; i++) {
            const word = listOfWords[i];
            if (word.length > 14) {
                return true;
            }
        }
        return false;
    };

    //NEW CONVERSATION CARD
    if (conversation?.slug === 'new-conversation') {
        return (
            <button
                className={classnames(
                    className,
                    styles.card,
                    styles.newConversationCard,
                    wideConversationCard && styles.wideConversationCard
                )}
                onClick={onClick}
            >
                <div className={styles.category}>{category.name}</div>
                <div className={styles.AddIconContainer}>
                    <AddIcon />
                </div>

                <div>{conversation.name}</div>
            </button>
        );
    }

    //NORMAL CONVERSATIONCARD
    return (
        <div
            className={classnames(
                styles.conversationCard,
                // { [styles.BreakWords]: hasLongWords(conversation?.name) },
                className,
                wideConversationCard && styles.wideConversationCard
                // styles.card,
                // styles[category?.slug],
                // userConversationClass
            )}
        >
            <button
                className={classnames(
                    { [styles.BreakWords]: hasLongWords(conversation?.name) },
                    buttonClassName,
                    styles.card,
                    styles[category?.slug],
                    userConversationClass,
                    wideConversationCard && styles.wideConversationCard
                )}
                onClick={onClick}
                style={{
                    backgroundImage: 'url("' + backgroundImage + '")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                {children}
            </button>

            {!showAll && (
                <span
                    className={classnames(
                        styles.title,
                        wideConversationCard && styles.wideConversationCard
                    )}
                >
                    {conversation?.title ?? conversation?.name}
                </span>
            )}
            {!showAll && (
                <span
                    className={classnames(
                        styles.category,
                        wideConversationCard && styles.wideConversationCard
                    )}
                >
                    {category?.name}
                </span>
            )}
        </div>
    );
};

export default ConversationCard;
